const BaseHeader = ({Element, timezone, headers}) => (
    <Element>
        <tr>
            <th>{timezone}</th>
            {headers.map(({key, className, label}) => (
                <th key={key} className={className}>{label}</th>
            ))}
        </tr>
    </Element>
);

export default BaseHeader;
